import script from "./FileLoaderModal.vue?vue&type=script&setup=true&lang=js"
export * from "./FileLoaderModal.vue?vue&type=script&setup=true&lang=js"

import "./FileLoaderModal.vue?vue&type=style&index=0&id=125eb022&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-125eb022"]])

export default __exports__